import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const FullContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  width: 100%;
  padding: 0;
  position: relative;
  ${props => (props.fullHeight ? "height: 100%;" : null)}
  ${props => (props.fullHeight ? "flex-grow: 1;" : null)}
`

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 1000px;
  width: 100%;
  padding: 0 16px 0 16px;
  ${props => (props.fullHeight ? "height: 100%;" : null)}
`

const DesktopContainer = ({ children, fullHeight }) => {
  return (
    <FullContainer fullHeight={fullHeight}>
      <Content fullHeight={fullHeight}>{children}</Content>
    </FullContainer>
  )
}

DesktopContainer.defaultProps = {
  fullHeight: false
}

DesktopContainer.propTypes = {
  fullHeight: PropTypes.bool
}

export default DesktopContainer
